// Projectile.js - How bullets look using image

export const drawProjectile = (ctx, proj, projectileImage) => {
  if (projectileImage) {
    ctx.save();
    
    // Calculate angle based on velocity
    const angle = Math.atan2(proj.vy, proj.vx);
    
    // Move to projectile center
    const centerX = proj.x + proj.w / 2;
    const centerY = proj.y + proj.h / 2;
    
    ctx.translate(centerX, centerY);
    ctx.rotate(angle + Math.PI / 2); // +90 degrees so image points up by default
    
    // Draw centered and rotated
    const width = proj.w * 5;
    const height = proj.h * 4;
    ctx.drawImage(projectileImage, -width/2, -height/2, width, height);
    
    ctx.restore();
  } else {
    // Fallback to yellow rectangle
    ctx.fillStyle = '#FFFF00';
    ctx.fillRect(proj.x, proj.y, proj.w, proj.h);
    
    ctx.fillStyle = '#FFD700';
    ctx.fillRect(proj.x + 1, proj.y, proj.w - 2, proj.h - 2);
  }
};

export const drawAllProjectiles = (ctx, projectiles, projectileImage) => {
  projectiles.forEach(proj => {
    drawProjectile(ctx, proj, projectileImage);
  });
};